import axios from 'axios';

const apiUrl = process.env.REACT_APP_ALCATRAZ_FLIGHT_SERVICE;

const postApi = {
  /**
   * Publish a post in flight service API
   * @param data The post info
   * @param type The offer type
   * @returns {object} res - result object
   */
  uploadPost: (type, data, token) => new Promise((resolve, reject) => {
    axios.post(`${apiUrl}/api/v1/post/${type}/`, data, {
      headers: {
        'x-access-token': token,
      },
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  }),
  /**
   * Update a post in flight service API
   * @param data The post info
   * @param type The offer type
   * @returns {object} res - result object
   */
  updatePost: (type, data, id, token) => new Promise((resolve, reject) => {
    axios.patch(`${apiUrl}/api/v1/post/${type}/${id}`, data, {
      headers: {
        'x-access-token': token,
      },
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  }),
  /**
   * Change post status in flight service API
   * @param mongoID The post ID
   * @param status The new status
   * @returns {object} res - result object
   */
  changeStatus: (data, mongoID, token) => new Promise((resolve, reject) => {
    axios.post(`${apiUrl}/api/v1/post/action/${mongoID}`, data, {
      headers: {
        'x-access-token': token,
      },
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  }),

  /**
   * Method to GET post by MongoId
   * @param id
   * @returns {Promise<>}
   */
  getPost: (id, token) => new Promise((resolve, reject) => {
    axios.get(`${apiUrl}/api/v1/post/${id}`, {
      headers: {
        'x-access-token': token,
      },
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  }),

  /**
   * actionPost method, updates a post status according to action
   * @param id
   * @param data
   * @returns {Promise<>}
   */
  actionPost: (id, data, token) => axios.post(`${apiUrl}/api/v1/post/action/${id}`, data, {
    headers: {
      'x-access-token': token,
    },
  }),
};

export default postApi;
